// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__39DXq","description":"PatientConsentPreview_description__32ubk"};